import {
  NON_CROPPABLE_EXTENSIONS as NON_CROPPABLE_EXTENSION_LIST,
  NON_CROPPABLE_MIMES as NON_CROPPABLE_MIME_LIST,
} from '@picsio/db/src/fileTypes';

const NON_CROPPABLE_EXTENSIONS = new Set(NON_CROPPABLE_EXTENSION_LIST);
const NON_CROPPABLE_MIMES = new Set(NON_CROPPABLE_MIME_LIST);

/**
 * Returns false for image formats whose converter pipeline in zipper does
 * NOT actually apply the `crop` / `cropAspect` params — so exposing crop UI
 * for them would mislead the user (they'd pick a region and get back the
 * untouched full image).
 *
 * Extension / MIME lists live in `@picsio/db` (`NON_CROPPABLE_*`).
 *
 * @param {string|undefined} mimeType
 * @param {string|undefined} [fileExtension]
 * @returns {boolean} true when the backend will honour a crop request
 */
export default function isCropSupportedFormat(mimeType, fileExtension) {
  if (fileExtension && typeof fileExtension === 'string') {
    const ext = fileExtension.toLowerCase().replace(/^\./, '').trim();
    if (ext && NON_CROPPABLE_EXTENSIONS.has(ext)) return false;
  }

  if (mimeType && typeof mimeType === 'string') {
    const m = mimeType.toLowerCase().trim();
    if (NON_CROPPABLE_MIMES.has(m)) return false;
  }

  return true;
}
